import(/* webpackMode: "eager" */ "/var/www/bikeparkmapa-node/releases/20260924_182829_329e241/apps/bikeparkmapa/app/[locale]/(home)/page.tsx");
